<template>
    <validation-observer  ref="remoteUser">
        <form class="formBox">
            <validation-provider :name="$t('customer.remoteUsers.username')" :rules="{ required: true, min: 3}" v-slot="validationContext">
                <b-form-group>
                    <b-row>
                        <b-col sm="4"> <label for="title"> {{$t('customer.remoteUsers.username')}} </label> </b-col>
                        <b-col sm="8"> 
                            <b-form-input
                                id="username"
                                v-model="username"
                                :state="getValidationState(validationContext)"
                                aria-describedby="live-feedback"
                            ></b-form-input>
                            <b-form-invalid-feedback id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                        </b-col>
                    </b-row>
                </b-form-group>
            </validation-provider>

            <validation-provider :name="$t('customer.remoteUsers.auth')" :rules="{ required: true }" v-slot="validationContext">
                <b-form-group>
                    <b-row>
                        <b-col sm="4"> <label for="title"> {{$t('customer.remoteUsers.auth')}} </label> </b-col>
                        <b-col sm="8"> 
                            <Multiselect  
                                id="auth"
                                v-model="selectedAuth"
                                :show-labels="false" 
                                :options="auth"
                                label="authority_name"
                                track-by="authority_code" >
                                    <template slot="singleLabel" slot-scope="{ option }">
                                        <strong>{{ option.authority_name }} </strong> 
                                    </template>
                            </Multiselect>
                            <b-form-invalid-feedback id="live-feedback" style="display: block">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>        
                        </b-col>
                    </b-row>
                </b-form-group>
            </validation-provider>

            <validation-provider :name="$t('customer.remoteUsers.email')" :rules="{ required: true, email: true}" v-slot="validationContext">
                <b-form-group>
                    <b-row>
                        <b-col sm="4"> <label for="title"> {{$t('customer.remoteUsers.email')}} </label> </b-col>
                        <b-col sm="8"> 
                            <b-form-input
                                id="email"
                                v-model="email"
                                :state="getValidationState(validationContext)"
                                aria-describedby="live-feedback"
                            ></b-form-input>
                            <b-form-invalid-feedback id="live-feedback" style="display: block">
                                {{ validationContext.errors[0] }}
                            </b-form-invalid-feedback>        
                        </b-col>
                    </b-row>
                </b-form-group>
               
            </validation-provider>

            <validation-provider :name="$t('customer.remoteUsers.phone')" :rules="{ required: true, regex: /^(\+\s\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/ }" v-slot="validationContext">
                <b-form-group>
                     <b-row>
                        <b-col sm="4"> <label for="title"> {{$t('customer.remoteUsers.phone')}} </label> </b-col>
                        <b-col sm="8"> 
                            <MaskedInput
                                id="phone"
                                v-model="phoneno"
                                mask="\+\ 11 (111) 111 1111"
                                placeholder="Phone number"
                                type="tel" 
                                :state="getValidationState(validationContext)"
                                aria-describedby="live-feedback"
                                class="form-control"
                            />
                        <b-form-invalid-feedback style="display:none" id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>     
                        </b-col>
                    </b-row>
                </b-form-group>
            </validation-provider>
            
            <validation-provider :name="$t('customer.remoteUsers.name')" :rules="{ required: true, min: 3}" v-slot="validationContext">
                <b-form-group>
                    <b-row>
                        <b-col sm="4"> <label for="title"> {{$t('customer.remoteUsers.name')}} </label> </b-col>
                        <b-col sm="8"> 
                        <b-form-input
                            id="firstname"
                            v-model="firstname"
                            :state="getValidationState(validationContext)"
                            aria-describedby="live-feedback"
                        ></b-form-input>
                        <b-form-invalid-feedback id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                        </b-col>
                    </b-row>
                </b-form-group>
                
            </validation-provider>

            <validation-provider :name="$t('customer.remoteUsers.lastname')" :rules="{ required: true, min: 3}" v-slot="validationContext">
                    <b-form-group>
                       <b-row>
                            <b-col sm="4"> <label for="title"> {{$t('customer.remoteUsers.lastname')}} </label> </b-col>
                            <b-col sm="8"> 
                            <b-form-input
                                id="lastname"
                                v-model="lastname"
                                :state="getValidationState(validationContext)"
                                aria-describedby="live-feedback"
                            ></b-form-input>
                            <b-form-invalid-feedback id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                            </b-col>
                        </b-row>  
                    </b-form-group>
            </validation-provider>
        
            <validation-provider  v-if="modalName=='add'" :name="$t('customer.remoteUsers.password')" :rules="{ required: true, min: 3}" v-slot="validationContext">
                <b-form-group>
                    <b-row>
                        <b-col sm="4"> <label for="title"> {{$t('customer.remoteUsers.password')}} </label> </b-col>
                        <b-col sm="8"> 
                            <b-form-input
                                id="password"
                                v-model="password"
                                :state="getValidationState(validationContext)"
                                aria-describedby="live-feedback"
                                type="password"
                            ></b-form-input>
                            <b-form-invalid-feedback id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                        </b-col>
                    </b-row>          
                </b-form-group>
                    
            </validation-provider>

            <validation-provider  v-if="modalName=='add'" :name="$t('customer.remoteUsers.passwordAgain')" :rules="{ required: true, min: 3, is: password}" v-slot="validationContext">
                <b-form-group>
                     <b-row>
                        <b-col sm="4"> <label for="title"> {{$t('customer.remoteUsers.passwordAgain')}} </label> </b-col>
                        <b-col sm="8"> 
                            <b-form-input
                                id="password2"
                                v-model="password2"
                                :state="getValidationState(validationContext)"
                                aria-describedby="live-feedback"
                                type="password"
                                
                            ></b-form-input>
                            <b-form-invalid-feedback id="live-feedback">{{ validationContext.errors[0] }}</b-form-invalid-feedback>
                        </b-col>
                    </b-row>
                </b-form-group>
            </validation-provider>           
        </form>
    </validation-observer>
</template>

<style lang="css" scoped > 
    @import "../styles/add.min.css"; 
</style>

<script>
    import MaskedInput from 'vue-masked-input'
    import Multiselect from 'vue-multiselect'
    import { Datetime } from 'vue-datetime';
    import moment from 'moment'
    import { VueEditor } from "vue2-editor";

    let states = [
        {text: "Hayır", value: false},
        {text: "Evet", value: true},
    ]
    export default {
        name: "RemoteUser",
        created:async function(){
           this.$store.dispatch('authGrp_list')
        },
        data: function() {
            return {
                username: this.data ? this.data.username : "",
                selectedAuth:{},
                email: "",
                firstname: "",
                lastname: "",
                password: "",
                state: this.data ? this.data.is_every_year : false,
                states
            }
        },
        props: {
            data: Object,
            save: Boolean,
            saveState: Function,
            modalName: String
        },
        methods:{
            getValidationState({ dirty, validated, valid = null }) {
                return dirty || validated ? valid : null;
            },
        },
        components:{
            Multiselect, Datetime, VueEditor, MaskedInput
        },
        computed:{
            loading(){
                return this.$store.getters.getAccountLoading
            },
            auth(){
                return this.$store.getters.getAuth
            },
        },
        watch: {
            save: function(data){
                if(data){
                    this.$refs.remoteUser.validate().then( async (success) =>{
                            if(success){
                                let data = {
                                    id : this.data && this.data.id,
                                    username: this.username,
                                    auth_code: selectedAuth.authority_code ,
                                    customer_info: {
                                        id: this.customer.data
                                    },
                                    email: this.email,
                                    firstname: this.firstname,
                                    lastname: this.lastname,
                                    password: this.password,
                                    user_type: 3
                                }
                                if(this.modalName == "add"){
                                    await this.$store.dispatch('saveUser', data)
                                }else{
                                    await this.$store.dispatch('updateAccountVacations', data)
                                }
                                if(this.$store.getters.getAccountStatus.status == "Success"){
                                    //await this.$store.dispatch('getAccountVacations', {accountId: this.$store.getters.accountId ? this.$store.getters.accountId.data : this.$route.params.id })
                                    this.saveState(false)
                                    if(this.modalName == "add"){
                                        this.username = ""
                                        this.selectedAuth = {}
                                        this.email = ""
                                        this.firstname = ""
                                        this.lastname = ""
                                        this.password = ""
                                    }
                                }
                            }
                        }
                    )
                }
                this.saveState(false)
            }
        }
        
    }
</script>


// WEBPACK FOOTER //
// src/pages/General/Customer/modals/RemoteUser.vue